import React from 'react'
import ProductPageContainer from '../../../../Components/Apps/ECommerce/ProductPage'

export default function ProductPage() {
  return (
    <div className='page-body'>
        <ProductPageContainer/>
    </div>
  )
}
